import type { FC } from 'react';

import { useLinkComponent } from '@eneco/link';
import { ButtonLink as ButtonLinkComponent } from '@eneco/sparky';
import { ButtonLink as Props } from '@sitecore/types/manual/ButtonLink';

export const ButtonLink: FC<Props> = ({ fields, params }) => {
  const Link = useLinkComponent();

  const buttonColor = params.buttonColor
    ? ((params.buttonColor === 'primary' ? 'primary' : params.buttonColor.toLowerCase()) as 'primary' | 'secondary')
    : undefined;

  return (
    <Link linkType={fields.buttonLink.value.linktype} linkValue={fields.buttonLink.value}>
      <ButtonLinkComponent action={buttonColor} target={fields.buttonLink.value.target ?? undefined}>
        {fields.buttonLink.value.text}
      </ButtonLinkComponent>
    </Link>
  );
};

export default ButtonLink;
